import { COMPLIANCE_TOS_LOCAL_STORAGE_KEY } from '@/components/ComplianceProvider/constants';

export async function fetchIsAllowed(address?: `0x${string}`): Promise<{ result: boolean }> {
  if (!address) {
    return { result: false };
  }

  const response = await fetch('/api/v1/compliance', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ address }),
  });

  if (!response.ok) {
    // We don't want to block users from accessing the app if the API is down, so
    // we return true here by default if there's an error.
    return { result: true };
  }

  return (await response.json()) as { result: boolean };
}

function getTosLocalStorageKey(address?: `0x${string}`): string {
  return `${COMPLIANCE_TOS_LOCAL_STORAGE_KEY}${address}`;
}

export function isTosLocalStorageAccepted(address?: `0x${string}`): boolean {
  return address && localStorage
    ? localStorage.getItem(getTosLocalStorageKey(address)) === 'true'
    : false;
}

export function acceptTosLocalStorage(address?: `0x${string}`): void {
  if (address && localStorage) {
    localStorage.setItem(getTosLocalStorageKey(address), 'true');
  }
}

/**
 * @deprecated This function appears unused and incorrectly references /api/compliance via GET.
 * It will be removed.
 */
// export async function checkCompliance(): Promise<boolean> {
//   const response = await fetch('/api/v1/compliance', {
//     method: 'GET',
//     headers: {
//       // ... existing code ...
//     },
//   });
//
//   // ... existing code ...
// }
